module.exports = __webpack_public_path__ + "img/main-sr-wheel-item-2.6961b1b.6961b1b5.png";